import React from 'react';
import { createPortal } from 'react-dom';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import {
  FooterIsFixedSelector,
  TranslationsSelector,
  ShowMoreInfoSelector,
  ShowFitAssistantSelector,
} from '../../Selectors/FitAssistantSelectors.ts';
import { setShowMoreInfo } from '../../Slices/FitAssistantSlice.ts';

import './Footer.less';
import { tabable } from '/Foundation/Common/code/Utils/WcagUtils.js';

const Footer = () => {
  const dispatch = useAppDispatch();
  const footerIsFixed = useAppSelector(FooterIsFixedSelector);
  const translations = useAppSelector(TranslationsSelector);
  const showMoreInfo = useAppSelector(ShowMoreInfoSelector);
  const showFitAssistant = useAppSelector(ShowFitAssistantSelector);

  const portal = document.querySelector('#moreInfoPortal');

  const handleClick = () => {
    dispatch(setShowMoreInfo(true));
  };
  const handleKeyUp = (e: React.KeyboardEvent) => {
    e.preventDefault();
    if (e.key === 'Enter') handleClick();
  };
  return portal && footerIsFixed ? (
    createPortal(
      <div className="footer-link fixed">
        <a
          tabIndex={tabable(showFitAssistant && !showMoreInfo)}
          className="w-100 text-center"
          onClick={() => handleClick()}
          onKeyUp={(e) => handleKeyUp(e)}
          role="button"
          data-component-label="FA - Can't find what you are looking for?"
        >
          {translations && translations.moreInfo}
        </a>
      </div>,
      portal
    )
  ) : (
    <div className="footer-link">
      <a
        tabIndex={tabable(showFitAssistant && !showMoreInfo)}
        className="w-100 text-center"
        onClick={() => handleClick()}
        onKeyUp={(e) => handleKeyUp(e)}
        role="button"
        data-component-label="FA - Can't find what you are looking for?"
      >
        {translations && translations.moreInfo}
      </a>
    </div>
  );
};

export default Footer;
